import { ArrowLeft, Check, ChevronRight } from "lucide-react";
import type { WorkflowDefinition } from "./types";

export function WorkflowFrame({
  children,
  definition,
  onNavigate,
}: {
  children: React.ReactNode;
  definition: WorkflowDefinition;
  onNavigate: (path: string) => void;
}) {
  return (
    <main className="workflow-page">
      <button
        className="workflow-back"
        onClick={() => onNavigate("/workflows")}
        type="button"
      >
        <ArrowLeft size={15} />
        返回组合工作流
      </button>
      <header className="workflow-page-header">
        <div>
          <h1>{definition.title}</h1>
          <p>{definition.summary}</p>
        </div>

      </header>
      <ol className="workflow-stage-strip">
        {definition.stages.map((stage, index) => (
          <li key={stage}>
            <span>{index + 1}</span>
            <strong>{stage}</strong>
            {index < definition.stages.length - 1 && <i />}
          </li>
        ))}
      </ol>
      <section className="workflow-body tool-surface">{children}</section>
      <details className="workflow-details"><summary>任务说明<ChevronRight size={15} /></summary><p>{definition.description}</p><p><strong>交付结果：</strong>{definition.outcome}</p></details>
      <p className="workflow-local-note">
        <Check size={15} />
        文件与处理结果不会上传到微言服务器；关闭页面后，内存中的任务文件随之释放。
      </p>
    </main>
  );
}
